// extracted by mini-css-extract-plugin
module.exports = {"loginOptions":"loginForm_loginOptions__phsbe","formWrapper":"loginForm_formWrapper__pDYKy"};